<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('containerClasses'))">
      <ul
        :id="id"
        :class="elementClasses(classes('classes'), classes('customClasses'))"
        :style="elementStyles(styles('styles'))"
      >
        <li
          v-for="(item, index) in contentItems"
          :key="index"
          class="hover-trigger"
          :class="elementClasses(classes('listsClasses'))"
        >
          <div class="wf-flex">
            <!-- If List Item hasIcon -->
            <div class="wf-px-2 wf-flex wf-items-start" v-if="content.hasIcon">
              <div
                class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center"
                :class="elementClasses(classes('iconContainerClasses'))"
                :style="elementStyles(styles('iconContainerStyles'))"
              >
                <i :style="elementStyles(styles('iconStyles'))" :class="[content.class, content.icon]"></i>
              </div>
            </div>
            <!-- Icon Content for Title and Description -->
            <div>
              <div
                class="focus:wf-outline-none wf-flex wf-items-center"
                :contenteditable="! previewMode"
                v-text="item.title"
                @input="updateItemTitle($event.target.textContent, index)"
              />
              <div
                v-if="content.hasDescription"
                class="focus:wf-outline-none wf-flex wf-items-center"
                :class="elementClasses(classes('descContainerClasses'))"
                :style="elementStyles(styles('descContainerStyles'))"
                :contenteditable="! previewMode"
                v-text="item.description"
                @input="updateItemDescription($event.target.textContent, index)"
              />
            </div>
            <!-- Button Only in Edit Mode -->
            <div class="wf-flex wf-justify-start wf-items-center hover-target">
              <div
                v-show="! previewMode"
                class="wf-relative wf-inline-block wf-ml-3 wf-pt-1 wf-right-0 wf-top-0 wf-overflow-visible wf-font-light wf-text-base wf-text-blue-500 wf-cursor-pointer"
                @click="removeItem(index)"
              ><i class="far fa-trash-alt"></i></div>
            </div>
          </div>
        </li>
        <li class="wf-flex wf-border-t wf-border-blue-200 wf-mt-2" v-show="! previewMode">
          <div class="wf-py-4 wf-pr-2 wf-text-base wf-text-blue-600"><i class="fas fa-plus"></i></div>
          <div
            contenteditable
            class="focus:wf-outline-none wf-flex wf-text-gray-700 wf-py-4 wf-font-normal"
            v-text="newItemTitle"
            @keydown.enter="addNewListItem($event.target.textContent)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import _ from "lodash";
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    data() {
      return {
        newItemTitle: 'New item title...'
      }
    },
    computed: {
      contentItems() {
        return this.$store.getters[`${this.module}/content`](this.element)['items'];
      }
    },
    methods: {
      updateItemTitle: _.debounce(function (newText, sourceIndex) {
        let listItems = Object.assign({}, {
          items: this.contentItems.map((item, index) => {
            return {
              title: index === sourceIndex ? newText : item.title,
              description: item.description
            }
          })
        })
        this.addToObject(this.module, listItems, 'content')
      }, 1000),

      updateItemDescription: _.debounce(function (newText, sourceIndex) {
        let listItems = Object.assign({}, {
          items: this.contentItems.map((item, index) => {
            return {
              title: item.title,
              description: index === sourceIndex ? newText : item.description
            }
          })
        })
        this.addToObject(this.module, listItems, 'content')
      }, 1000),

      removeItem: _.debounce( function(sourceIndex) {
        let contentListItems = Object.assign({}, {
          items: this.contentItems.filter((item, index) => index !== sourceIndex)
        });
        this.addToObject(this.module, contentListItems, 'content')
      }, 1000),

      addNewListItem: _.debounce( function(newText) {
        this.addToObject(this.module, Object.assign({}, {
            items: [...this.contentItems, {title: newText}]
          }), 'content')
      }, 1000)
    }
  })
</script>

<style lang="css">
  .hover-trigger .hover-target {
    display: none;
  }

  .hover-trigger:hover .hover-target {
    display: block;
  }
</style>
